import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { BrandService } from '../../../services/index';

@Component({
    selector: 'add-edit-brand-window',
    templateUrl: './addEditBrand.component.html'
})
export class AddEditBrandComponent implements OnInit {
    public title: string;
    public mode: string;
    public list: any[] = [];
    public branddata: any[] = [];

    // trigger-variable for Ladda
    isLoading: boolean = false;
    @Output() brandLoadEvent = new EventEmitter();

    constructor(private brandService: BrandService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService) {

    }

    ngOnInit(): void {
        setTimeout(() => {
            $('#brand_name').focus();
        }, 100);
    }

    onSaveBrand(): void {
        let that = this;
        this.isLoading = true;
        this.brandService
            .addUpdateBrand(this.branddata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.brandLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }

            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/brand/addEditBrand.component.ts